import { render, staticRenderFns } from "./SigH4Title.vue?vue&type=template&id=32590e64"
import script from "./SigH4Title.vue?vue&type=script&lang=ts"
export * from "./SigH4Title.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports